import { Controller } from 'stimulus'

export default class extends Controller {
  openPreview(event) {
    const index = event.params.previewIndex
    const sliderContainer = this.element.querySelector('.js-splide-container')

    if (!sliderContainer) {
      return
    }

    event.preventDefault()
    sliderContainer.dispatchEvent(
      new CustomEvent('splide:openPreviewSplide', {
        detail: { index },
        bubbles: true,
      })
    )
  }
}
